import React from 'react'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import RetractablePanel from 'components/RetractablePanel'
import Input from 'components/Input'
import Button from 'components/Button'

import { statusChanged } from 'components/RequestStatus/actions'
import { claimChanged } from 'scenes/VehicleDetail/actions'

import { CLAIM_UPDATE } from 'constants'

import './styles.scss'

export class Assistance extends BaseComponent {


  constructor(props) {
    super(props)
    this.state = {
      editting: false,
      assistance_worker_name: props.claim.assistance_worker_name || '',
      assistance_worker_phone: props.claim.assistance_worker_phone || '',
      assistance_arrived: this.props.claim.assistance_arrived
    }

    this._bind( 
                '_onEdit', '_renderEditForm', '_renderData', '_handleSubmit', 
                '_renderButton', '_handleChange', '_onCancelEdit',
                '_renderAssistance', '_renderAssistanceForm')
  }

  componentDidMount() {
  
  }

  _onEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.setState({ editting: true })
  }

  _onCancelEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.setState({ editting: false })
  }

  _renderHeaderActions() {
    return !this.state.editting ? (
      <div>
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : (
      <div>
        <button onClick={this._onCancelEdit}>
          <i className="material-icons">close</i>
        </button>
      </div>
    )
  }

  _renderButton() {
    const isActive = this.state.isActive
    const isClosed = this.state.isClosed
    if(isActive && isClosed === false) {
      return (
        <button type="button" className="btn btn-outline-danger" onClick={this._claimStatus} name="is_closed">Terminar seguimiento</button>
      )
    } else {
      return (
        <button type="button" className="btn btn-outline-success" onClick={this._claimStatus} name="is_active">Iniciar seguimiento</button>
      )
    }
  }

  _handleSubmit(e) {
    e.preventDefault()
    const formData = new FormData()
    var assistanceArrived = this.state.assistance_worker_name !== '' || this.state.assistance_worker_phone !== ''
    this.setState({
      assistance_arrived: assistanceArrived
    })

    formData.append('assistance_arrived', assistanceArrived)

    if(assistanceArrived){
      formData.append('assistance_worker_name', this.state.assistance_worker_name)
      formData.append('assistance_worker_phone', this.state.assistance_worker_phone) 
    }else{
      formData.append('assistance_worker_name', '') 
      formData.append('assistance_worker_phone', '') 
    }

    this.props.updateRequestStatus('progress', 'Modificando datos del siniestro...')
    request(CLAIM_UPDATE(this.props.claim.id), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.updateRequestStatus('ok', 'Datos modificados')
      this.props.claimChanged({
        ...this.props.claim,
        assistance_arrived: assistanceArrived,
        assistance_worker_name: this.state.assistance_worker_name,
        assistance_worker_phone: this.state.assistance_worker_phone
      })
    }).catch((err) => {this.props.updateRequestStatus('error', 'No pudimos modificar los datos')})

    this.setState({
      editting: false
    })
  }

  _handleChange(e) {
    this.setState({ [e.target.name]: e.target.value })      
  }

  _renderEditForm() {
    return(
      <form onSubmit={this._handleSubmit} className="AssistanceData__form">
        {this._renderAssistanceForm()}
        <div className="controls d-flex justify-content-end">
          <Button buttonType="primary"
                  size="small">Actualizar siniestro</Button>
        </div>
      </form>
    )
  }

  _renderAssistanceForm() {
    return (
      <div className="AssistanceDataForm">
        <div className="form-field">
          <label>Nombre:</label>
          <Input  onChange={this._handleChange}
                name="assistance_worker_name"
                value={this.state.assistance_worker_name}
                placeholder="Nombre del ajustador"/>
        </div>
        <div className="form-field">
          <label>Teléfono:</label>
          <Input  onChange={this._handleChange}
                name="assistance_worker_phone"
                value={this.state.assistance_worker_phone}
                placeholder="Teléfono del ajustador"/>
        </div>
      </div>
    )
  }

  _renderData() {
    return(
      <div className="AssistanceData__data">
        {this._renderAssistance()}
      </div>
    )
  }

  _renderAssistance() {
    const assistanceArrived = this.props.claim.assistance_arrived

    return !!assistanceArrived ? (
      <div>
        <div className="data-field">
          <label>Nombre:</label>
          <p><span>{this.props.claim.assistance_worker_name}</span></p>
        </div>
        <div className="data-field">
          <label>Teléfono:</label>
          <p><span>{this.props.claim.assistance_worker_phone}</span></p>
        </div>
      </div>
    ) : (
      <center><p><span>No registrado</span></p></center>
    )
  }

  render() {
    return(
      <div id="AssistanceData" className="AssistanceData">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Datos del ajustador"
          actionButtons={this._renderHeaderActions()}
          isToggle={true}
        >
          {this.state.editting ? this._renderEditForm() : this._renderData() }
        </RetractablePanel>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    claim: state.vehicleDetail.get('claim')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Assistance)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/Assistance/index.js